import { Classes, Colors, IconSize } from '@blueprintjs/core';
import classNames from 'classnames';
import * as React from 'react';

import { IconProps } from 'src/components/icons/types';

export const Outbound: React.VFC<IconProps> = ({
  className,
  color = Colors.GRAY1,
  iconSize = IconSize.STANDARD,
}) => (
  <svg
    className={classNames('sd-icon', Classes.ICON, className)}
    height={iconSize}
    viewBox="0 0 60 60"
    width={iconSize}
  >
    <g clipPath="url(#clip0)">
      <path
        clipRule="evenodd"
        d="M60 30.0118C59.9437 29.29 59.6236 28.4087 59.1486 27.934L47.0387 15.8539C46.5116 15.3272 45.8012 15 44.9813 15C43.3707 15 41.9978 16.3837 41.9978 17.9933C41.9978 18.8127 42.3206 19.5797 42.8477 20.1065L49.9831 27.0189L26.9261 27.0189C25.3155 27.0189 23.9978 28.4022 23.9978 30.0118C23.9978 31.6214 25.3155 32.9903 26.9261 32.9903C27.9998 32.9903 35.6757 32.9903 49.9538 32.9903L42.8477 39.9473C42.3206 40.4741 41.9978 41.1883 41.9978 42.0077C41.9978 43.6173 43.3707 45 44.9813 45C45.8012 45 46.5116 44.6982 47.0387 44.1422L59.1193 32.0604C59.596 31.5839 59.9407 30.7322 60 30.0118Z"
        fill={color}
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M23.9978 30.0118C23.8744 36.5332 18.55 41.7818 12 41.7818C5.37259 41.7818 -3.8147e-06 36.4084 -3.8147e-06 29.7801C-3.8147e-06 23.1518 5.37259 17.7785 12 17.7785C18.5472 17.7785 23.8699 23.4943 23.9978 30.0118Z"
        fill={color}
        fillRule="evenodd"
      />
    </g>
    <defs>
      <clipPath id="clip0">
        <rect fill="white" height="60" width="60" />
      </clipPath>
    </defs>
  </svg>
);
